import get from 'lodash/get';
import { propsEvalOrReturn } from './propsEvalOrReturn.js';

function getThemeValue(keys, defaultValue) {
  return function (props) {
    var _props$theme = props.theme,
        theme = _props$theme === void 0 ? {} : _props$theme;
    var result = get(theme, keys);

    if (result === undefined) {
      result = defaultValue;
    }

    return propsEvalOrReturn(result, props);
  };
}

export { getThemeValue };
